<template>
    <div style="box-sizing: border-box;padding-top: 20px;">
        <div class="forms">
            <div class="formTitle flx alc">
                <div class="bshu"></div>
                <div class="ftname">
                    <span style="color: #007AFF;">1</span>/2 职位基本信息
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>上传小程序端封面图:</span>
                </div>
                <div>
                    <div class="ips">
                        <el-upload class="upload-demo" action="https://two.hrxsl.com/api/Common/oss_upload"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                            :show-file-list="false">
                            <div class="upimage">
                                <img v-if="!forms.avatar" :src="$Localimg('uploadImage.png')" alt="" />
                                <img v-else :src="$img(forms.avatar)" alt="" @click="previewImage($img(forms.avatar))" style="cursor:pointer"/>
                            </div>
                        </el-upload>
                    </div>
                    <div class="tis">
                        <div class="tiitem" style="margin-left: 0;margin-top: 12px;">
                            图片单张大小不能超过5M，尺寸推荐820*530像素，支持JPG\PNG格式
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>上传电脑端封面图:</span>
                </div>
                <div>
                    <div class="ips">
                        <el-upload class="upload-demo" action="https://two.hrxsl.com/api/Common/oss_upload"
                            :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1" :headers="uploadHeaders"
                            :show-file-list="false">
                            <div class="upimage">
                                <img v-if="!forms.pc_avatar" :src="$Localimg('uploadImage.png')" alt="" />
                                <img v-else :src="$img(forms.pc_avatar)" alt="" @click="previewImage($img(forms.pc_avatar))" style="cursor:pointer"/>
                            </div>
                        </el-upload>
                    </div>
                    <div class="tis">
                        <div class="tiitem" style="margin-left: 0;margin-top: 12px;">
                            图片单张大小不能超过5M，尺寸推荐820*530像素，支持JPG\PNG格式
                        </div>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>职位名称:</span>
                </div>
                <div class="ips">
                    <div style="width: 500px;">
                        <el-input placeholder="请输入职位名称" v-model="forms.name">
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="formitem flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>职位描述:</span>
                </div>
                <div class="ips">
                    <div style="width: 500px;">
                        <el-input :rows="6" maxlength="2000" :show-word-limit="true" type="textarea" resize="none" count
                            placeholder="请输入内容" v-model="forms.content">
                        </el-input>
                    </div>
                </div>
                <div style="margin-left: 10px;">
                    <el-button @click="autoin" type="primary">AI帮写</el-button>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>公司规模:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select v-model="forms.scale_id" placeholder="请选择公司规模">
                            <el-option v-for="item in gmArr" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>职位类别:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select v-model="forms.position_id" placeholder="请选择职位类别">
                            <el-option v-for="item in gArr" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formTitle flx alc">
                <div class="bshu"></div>
                <div class="ftname">
                    <span style="color: #007AFF;">2</span>/2 职位要求
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>学历要求:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select v-model="forms.eb_id" placeholder="请选择学历要求">
                            <el-option v-for="item in xArr" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>经验要求:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select v-model="forms.exp_id" placeholder="请选择">
                            <el-option v-for="item in jArr" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>行业类别:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-select v-model="forms.industry_id" placeholder="请选择">
                            <el-option v-for="item in hArr" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame t10" >
                    <span style="color: #FF4949;">*</span>
                    <span>薪资范围:</span>
                </div>
                <div class="ips">
                    <div style="width: 500px;" class="flx alc">
                        <div class="ipll flx alc">
                            <el-input :show-word-limit="true" placeholder="请输入最低薪资" v-model="forms.salary_mix">
                            </el-input> <span style="margin-left: 8px;">K</span>
                        </div>
                        <div style="margin: 0 10px;color: #d9d9d9;font-size: 20px;font-weight: bold;">-</div>
                        <div class="ipll flx alc">
                            <el-input :show-word-limit="true" placeholder="请输入最高薪资" v-model="forms.salary_max">
                            </el-input> <span style="margin-left: 8px;">K</span>
                        </div>
                    </div>
                    <div class="tso">
                        薪资单位为K，1K=1000元，请填写数字（例：8 代表8000，不要填8000）
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>工作地点:</span>
                </div>
                <div class="ips">
                    <el-cascader v-model="areaValue" :options="areaList" :props="areaProps"
                        :placeholder="areaValue.length > 0?fullName : '请选择省/市/区'" clearable
                        @change="handleAreaChange"></el-cascader>
                </div>
            </div>
            <div class="bot">
                <el-button type="primary" plain @click="subThis(source == 2?4:3)">存为草稿</el-button>
                <el-button type="primary" :loading="subing" @click="subThis(source == 2?1:2)">发布招聘</el-button>
                <div class="rules flx alc jsc">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="torules(7)">《服务使用协议》</b><b
                            class="cursor" style="color:#007AFF" @click="torules(4)">《招聘规范》</b>
                    </div>
                </div>
            </div>
            <!-- 图片预览弹窗，和前面页面完全统一 -->
            <el-image-viewer
                v-if="previewVisible"
                :url-list="previewList"
                :initial-index="previewIndex"
                @close="previewVisible = false"
            />
        </div>
    </div>
</template>
<script>
    import {
        getpoInfo,
        publicZp,
        recruBk,
        AIzww
    } from "@/api/index.js"
    import areaList from '@/assets/area.json'
    export default {
        name: "editposition",
        data() {
            return {
                gArr: [],
                gmArr: [],
                hArr: [],
                jArr: [],
                xArr: [],
                areaValue: [],
                areaList: areaList,
                fullAddress: '',
                // 级联配置
                areaProps: {
                    value: 'value',
                    label: 'label',
                    children: 'children'
                },
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                forms: {
                    avatar: "",
                    name: "",
                    eb_id: "",
                    salary_max: "",
                    salary_mix: "",
                    position_id: "",
                    exp_id: "",
                    scale_id: "",
                    industry_id: "",
                    province_id: "",
                    city_id: "",
                    area_id: "",
                    content: "",
                    pc_avatar: "",
                },
                hasRead: false,
                source: "",
                id: "",
                fullName: "",
                subing: false,
                // 图片预览变量，和其他页面保持一致
                previewVisible: false,
                previewList: [],
                previewIndex: 0
            }
        },
        created() {
            this.id = this.$route.query.id
            this.source = this.$route.query.source
            this.getDetail()
        },
        methods: {
            // 预览方法，统一
            previewImage(url) {
                this.previewList = [url]
                this.previewIndex = 0
                this.previewVisible = true
            },
            autoin() {
                let that = this
                if (that.forms.name == '') {
                    this.$message.error('请填写职位名称')
                } else {
                    let data = that.forms.name
                    AIzww(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.forms.content = res.data.content
                        }
                    })
                }
            },
            handleAreaChange(e) {
                console.log(e)
                console.log(this.areaValue)
                this.forms.province_id = this.areaValue[0]
                this.forms.city_id = this.areaValue[1]
                this.forms.area_id = this.areaValue[2]
            },
            getDetail() {
                let that = this
                let data = {}
                data.id = that.id
                data.source = that.source
                recruBk(data).then((res) => {
                    console.log("pdetrai/", res)
                    if (res.code == 1) {
                        that.gArr = res.data.gangwei
                        that.gmArr = res.data.gongsiguimo
                        that.hArr = res.data.hangye
                        that.jArr = res.data.jingyan
                        that.xArr = res.data.xueli
                        that.forms.avatar = res.data.info.avatar
                        that.forms.name = res.data.info.name
                        that.forms.eb_id = res.data.info.eb_id
                        that.forms.salary_max = res.data.info.salary_max
                        that.forms.salary_mix = res.data.info.salary_mix
                        that.forms.position_id = res.data.info.position_id
                        that.forms.exp_id = res.data.info.exp_id
                        that.forms.scale_id = res.data.info.scale_id
                        that.forms.industry_id = res.data.info.industry_id
                        that.forms.province_id = res.data.info.province_id
                        that.forms.city_id = res.data.info.city_id
                        that.forms.area_id = res.data.info.area_id
                        that.forms.content = res.data.info.content
                        that.forms.pc_avatar = res.data.info.pc_avatar
                        that.content = res.data.info.content
                        that.fullName = res.data.info.province_name + '/' + res.data.info.city_name + "/" + res
                            .data.info.area_name
                        that.areaValue.push(res.data.info.province_id)
                        that.areaValue.push(res.data.info.city_id)
                        that.areaValue.push(res.data.info.area_id)
                    }
                })
            },
            getInfo() {
                let that = this
                getpoInfo().then((res) => {
                    console.log("add", res)
                    if (res.code == 1) {
                    }
                })
            },
            torules(e) {
                window.open('https://two.hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },
            subThis(e) {
                let that = this
                if (that.hasRead == false) {
                    this.$message.error('请勾选并阅读相关协议')
                    return
                }
                that.subing = true
                let data = that.forms
                data.id = that.id
                data.source = e
                if(e == 1){
                    data.draft_id = that.id
                }
                publicZp(data).then((res) => {
                    that.subing = false
                    if (res.code == 1) {
                        // that.$message.success(res.msg)
                        if (e == 4 || e == 3) {
                            setTimeout(() => {
                                that.$router.push('/cgsuccess')
                            }, 2000)
                        } else {
                            setTimeout(() => {
                                that.$router.push('/punSuccess')
                            }, 2000)
                        }
                        // setTimeout(() => {
                        //     that.$router.push('/punSuccess')
                        // }, 2000)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.avatar = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            handleAvatarSuccess1(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.pc_avatar = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024
                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }
                // 校验通过，允许上传
                return true
            },
            beforeAvatarUpload1(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024
            
                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }
            
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }
            
                // 校验通过，允许上传
                return true
            }
        }
    }
</script>
<style scoped>
    .t10{
        position: relative;
        top: -10px;
    }
    .tso{
        color: red;
        font-size: 14px;
        margin-top: 10px;
        text-align: left;
    }
    .upload-demo {
        width: 167px !important;
        height: 97px !important;
    }
    .ipll {
        flex: 1;
    }
    .el-cascader .el-input .el-input__inner {
        width: 500px !important;
    }
    .el-select {
        width: 100% !important;
    }
    textarea {
        resize: none !important;
    }
    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }
    .rules {
        margin-top: 24px;
    }
    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }
    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }
    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }
    .formitem {
        margin-bottom: 30px;
    }
    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }
    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        width: 258px;
        text-align: right;
    }
    .ips .inps {
        width: 500px;
        height: 46px;
    }
    .upimage {
        width: 167px;
        height: 97px;
    }
    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .formTitle {
        margin-bottom: 31px;
    }
    .ftname {
        font-weight: 500;
        font-size: 18px;
    }
    .bshu {
        width: 3px;
        height: 16px;
        background: #007AFF;
        margin-right: 12px;
    }
    .forms {
        width: 1460px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 64px 40px;
    }
</style>
